export default "<div *ngIf=\"date\" class=\"date\" (click)=\"clicked()\">{{dateString}}</div>\n";